import { Text, Tooltip } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import {
  ACTION_ICON,
  ACTION_NAME_KEY,
  selectActionCellIcons
} from "@/organisms/Drawers/components/TriageDrawer/components/TakenActions"

import styles from "./TakenActionsCell.module.scss"

import type { TakenActionsCellProps } from "./TakenActionsCell.types"

const MAX_ICONS = 2

export const TakenActionsCell = ({ actions }: TakenActionsCellProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.remediation.actions.types"
  })

  if (!actions.length) return null

  const { shown, hidden } = selectActionCellIcons(actions, MAX_ICONS)

  return (
    <div className={styles.cell}>
      <div className={styles.icons}>
        {shown.map((type) => {
          const Icon = ACTION_ICON[type]
          const name = t(ACTION_NAME_KEY[type])

          return (
            <Tooltip key={type} title={name}>
              <span aria-label={name} role="img">
                <Icon />
              </span>
            </Tooltip>
          )
        })}
      </div>
      {hidden > 0 && <Text className={styles.more}>{`+${hidden}`}</Text>}
    </div>
  )
}
